export { VALIDATOR_TYPE, timeValidator } from "./timeValidator.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/validators/timeValidator/index.mjs
// module id = 600
// module chunks = 1